<template>
  <div>
    <div
      v-if="isVisible"
      class="jProgressScreen">
      <div
        id="progress-screen"
        class="notification-screen">
        <div class="floating-container">
          <span>
            <i class="fa fa-check-circle"/>
          </span>
          <h1 id="progress-screen-data">Processing {{ retrievedData.length }}/{{ max }}</h1>
          <b-progress
            :max="max"
            class="mb-3">
            <b-progress-bar
              :value="numOfFailed"
              variant="danger"/>
            <b-progress-bar
              :value="numOfSuccess"
              variant="success"/>
          </b-progress>
          <div id="progress-screen-message">
            <span class="span__success--green">{{ numOfSuccess }} data success</span>
            <br>
            <span class="span_failed--red">{{ numOfFailed }} data failed</span>
            <div
              v-if="getErrorDatas.length > 0"
              id="progress-message-container">
              <p>Problem Message:</p>
              <div id="box">
                <p
                  v-for="(errorData, index) in getErrorDatas"
                  :key="index">
                  - Data {{ errorData.index }}: {{ errorData.message }}.
                </p>
              </div>
            </div>
          </div>
          <br>
          <b-button
            v-if="finish"
            id="progress-screen-finish"
            variant="success"
            @click="toggleIsVisible">
            Finish
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-console, no-unused-vars, no-eval, no-mixed-operators, no-underscore-dangle, no-param-reassign */
import jApi from '@/services/jApi';

export default {
  name: 'JProgressScreen',
  props: {
    dataKirim: {
      type: Array,
      default: () => ([]),
    },
    urlApi: {
      type: String,
      default: '',
    },
    headers: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      numOfFailed: 0,
      numOfSuccess: 0,
      max: 0,
      retrievedData: [],
      isVisible: false,
      finish: false,
      transportation_id: [],
      progress: 0,
    };
  },
  computed: {
    getErrorDatas() {
      return this.retrievedData.filter((data, index) => {
        if (data.error === true) {
          const datas = data;
          datas.index = index + 1;
          datas.message = datas.message;
          return datas;
        }
        return '';
      });
    },
  },
  watch: {
    retrievedData() {
      if (this.isVisible) {
        this.progress += 1;
        this.numOfFailed = this.getErrorDatas.length;
        this.numOfSuccess = this.retrievedData.length - this.numOfFailed;
        if (this.progress < this.dataKirim.length) {
          this.submitRecord();
        } else {
          this.finish = true;
        }
      } else {
        this.progress = 0;
        this.numOfSuccess = 0;
      }
    },
  },
  methods: {
    toggleIsVisible() {
      this.isVisible = !this.isVisible;
      if (this.isVisible) {
        this.submitRecord();
      } else {
        this.$emit('finish', this.retrievedData);
        this.retrievedData = [];
        this.max = 0;
      }
    },

    async submitRecord() {
      this.finish = false;
      this.max = this.dataKirim.length;
      const api = jApi.generateApi();

      let method = 'post';
      let url = this.urlApi;
      let param = this.dataKirim[this.progress];
      if (this.dataKirim[this.progress].action === 'delete') {
        method = 'delete';
        url = `${this.urlApi}/${this.dataKirim[this.progress].id}`;
        param = {};
      }
      delete param.action;
      await api[method](url, param)
        .then((response) => {
          this.retrievedData.push(response.data);
        })
        .catch((error) => {
          this.retrievedData.push(error.response.data);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/progress-screen/jProgress.vue